import React, { Dispatch, SetStateAction } from "react";
import useMyOrdersHook, { MyOrdersContentTypes } from "./myOrders-hook";
import { IBusinessProfile, IServices } from "../../../../../../../Interfaces/responseTypes";
import { VisitorPageContents } from "../../../../visitorPage";
import OrderList from "./Contetnts/OrderList/myOrderList";
import OrderItem from "./Contetnts/OrderItem/orderItem";
import MyOrdersHeader from "../../Components/Headers/MyOrdersHeader/myOrdersHeader";
import styles from "./myOrders.module.scss";

interface IProps {
  company_id: number,
  is_user: boolean,
  logo: string,
  setContentType: Dispatch<SetStateAction<VisitorPageContents>>,
  business_profile?: IBusinessProfile;
  services: IServices | null,
  onOpenReserveDialog: () => void
};

const MyOrders: React.FC<IProps> = (props) => {
  const { company_id, is_user, logo, business_profile, services, setContentType, onOpenReserveDialog } = props;
  const {
    orders,
    activeContent,
    selectedOrder,
    selectOrder,
    goBackToList,
    sentinelRef,
    isFetching
  } = useMyOrdersHook(setContentType);

  return (
    <div className={styles.page}>
      <MyOrdersHeader
        companyId={company_id}
        is_user={is_user}
        logo={logo}
        setContentType={setContentType}
        business_profile={business_profile}
        services={services}
        onOpenReserveDialog={onOpenReserveDialog}
      />

      <div className={styles.pageContent}>
        {activeContent === MyOrdersContentTypes.ORDER_LIST && (
          <OrderList
            orders={orders}
            onSelect={selectOrder}
            sentinelRef={sentinelRef}
            isFetching={isFetching}
          />
        )}

        {activeContent === MyOrdersContentTypes.ORDER_ITEM && selectedOrder && (
          <OrderItem
            order={selectedOrder}
            onBack={goBackToList}
            business_profile={business_profile}
            setContentType={setContentType}
          />
        )}
      </div>
    </div>
  );
};

export default MyOrders;
